import React from 'react'

function BecomeCreator() {
  return (
    <div>BecomeCreator</div>
  )
}

export default BecomeCreator